import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  DoctorReportDto,
  DoctorReportLabResultDataDto,
  DoctorReportMedicamentDataDto,
  DoctorReportSynopsisDataDto,
  PdfResponse
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/doctor-report`;

export const getSynopsisReportData = (
    patientId: number,
    source: CancelTokenSource): Promise<DoctorReportSynopsisDataDto> => {

  return axios
      .get(`${apiUri}/synopsis-data/${patientId}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getMedicamentData = (
    patientId: number,
    source: CancelTokenSource): Promise<DoctorReportMedicamentDataDto> => {

  return axios
      .get(`${apiUri}/medicament-data/${patientId}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const getLabResultData = (
    patientId: number,
    source: CancelTokenSource): Promise<DoctorReportLabResultDataDto> => {

  return axios
      .get(`${apiUri}/lab-result-data/${patientId}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const generateDoctorReport = (
    patientId: number,
    doctorReportDto: Partial<DoctorReportDto>,
    source: CancelTokenSource): Promise<PdfResponse> => {

  return axios
      .post(`${apiUri}/${patientId}/doctor-report`,
          doctorReportDto, {cancelToken: source.token})
      .then(response => response.data);
};
